import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const front = defineConnector({
  identifier: "front",
  name: "Front",
  tagLine: "Customer communication platform",
  keywords: "frontapp shared inboxes email conversations support helpdesk",
  logo,
  protocol: "http",
  tags: ["productivity", "communication"],
  defaultUrlPattern: () => "https://api2\\.frontapp\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Front API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Front Developer Settings](https://app.frontapp.com/settings/tools/api) and generate an **API Token**.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API Token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api2.frontapp.com/me",
  },
});
